import React, { useEffect, useState } from "react";
import baseUrl from "../../../config/baseUrl"
import axios from "axios";
import { Card, CardContent, Box, Typography, TextField, Grid, Button, InputAdornment, IconButton, CircularProgress, Checkbox, Autocomplete  } from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import SandboxDepositsTable from "./SandboxDepositsTable";
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import FilterCreatedOn from "../../../date/FilterCreatedOn";
import FilterUpdatedOn from "../../../date/FilterUpdatedOn";
import { useStateContext } from "../../../context/ContextProvider";

const icon = <CheckBoxOutlineBlankOutlinedIcon fontSize="small" />;
const checkedIcon = <CheckBoxOutlinedIcon fontSize="small" />;

const SandboxDeposits = ({ authCreate, authRead, authUpdate, authDelete }) => {
  const { dropdownMerchant } = useStateContext();
  const [downloadLoading, setDownloadLoading] = useState(false);

  const auth = sessionStorage.getItem("user");
  const [merchant, setMerchant] = useState([]);
  const [searchItem, setSearchItem] = useState("");
  const [createdTo, setCreatedTo] = useState("")
  const [createdFrom, setCreatedFrom] = useState("")
  const [updatedTo, setUpdatedTo] = useState("")
  const [updatedFrom, setUpdatedFrom] = useState("")
  const [selectedMethods, setSelectedMethods] = useState([])
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [currencyName, setCurrencyName] = useState([]); 
  const [selectedCurrencies, setSelectedCurrencies] = useState([]); 
  const [message, setMessage] = useState("");
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [refundCharges, setRefundCharges] = useState("")
  const [loading, setLoading] = useState(false);

  const handleChange = (event, newValue) => {
    if (!Array.isArray(newValue)) return;
    const selectedValues = newValue.filter(Boolean).map((item) => item.value);
    setSelectedTypes(selectedValues);
  };

  const handleChange1 = (event, newValue) => {
    if (!Array.isArray(newValue)) return;
    const selectedValues = newValue.filter(Boolean).map((item) => item.value);
    setSelectedMethods(selectedValues);
  };

  const ReadData = async () => {
    try {
      setLoading(true)
      let values = { 
        page: page, 
        searchText: searchItem, 
        limit: 10,
        to: createdTo,
        from: createdFrom,
        To: updatedTo,
        From: updatedFrom,
        method: selectedMethods,
        status: selectedTypes,
        currency: selectedCurrencies.map((currency) => currency.value),
        id: dropdownMerchant
      };
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${auth}`,
        },
      };
      let result = await axios.post(`${baseUrl}/searchSandboxDepositsDateFilter`, values, config);
      setMessage((result.data.message).toUpperCase());
      setTotalPage(Number(result.data.totalPages));
      const fetchedData = result.data.data;
      setMerchant(fetchedData);
      setRefundCharges(result.data.userRefund)
    } catch (error) {
      console.log(error);
    } finally{
      setLoading(false)
    }
  };

  const merchantData = async () => {
    try {
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${auth}`,
        },
      };

      let result1 = await axios.post(`${baseUrl}/merchantChoosedCurrency`, {}, config);
      if (Array.isArray(result1.data.data)) {
        setCurrencyName(result1.data.data);
      } else {
        console.error("Expected an array but got:", result1.data.data);
        setCurrencyName([]);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const methods = [
    { value: "Card", label: "Card" },
    { value: "UPI", label: "UPI" },
    { value: "NetBanking", label: "NetBanking" },
    { value: "Wallet", label: "Wallet" },
    { value: "QRCode", label: "QR Code" },
  ];

  const types = [
    { value: "0", label: "Failed" },
    { value: "1", label: "Success" },
    { value: "2", label: "Waiting" },
    { value: "3", label: "Pending" },
    { value: "4", label: "Refund" },
    { value: "5", label: "Chargeback" },
    { value: "9", label: "Chargeback Settled" },
  ];

  const handleClear = () => {
    setSearchItem(""); // Clear the state
  };

  useEffect(() => {
    ReadData();
  }, [page, searchItem, createdTo, createdFrom, updatedTo, updatedFrom, selectedMethods, selectedTypes, selectedCurrencies, dropdownMerchant]);
  
  useEffect(() => {
    merchantData(); 
  }, []);

  const downloadExl = () => {
    const auth = sessionStorage.getItem("user");
    setDownloadLoading(true);

    const values = {
      searchText: searchItem || undefined,
      to: createdTo || undefined,
      from: createdFrom || undefined,
      To: updatedTo || undefined,
      From: updatedFrom || undefined,
      method: selectedMethods.length ? selectedMethods : undefined,
      status: selectedTypes.length ? selectedTypes : undefined,
      currency: selectedCurrencies.length ? selectedCurrencies.map((c) => c.value) : undefined,
      id: dropdownMerchant
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${auth}`,
      },
      responseType: "json",
    };

    axios
    .post(`${baseUrl}/downloadSandboxDepositsapi`, values, config)
    .then((res) => {
      if (
        res.data &&
        typeof res.data === "object" &&
        ("depositCSV" in res.data)
      ) {
        // Download each CSV string if it exists
        const downloadCSV = (csvString, filename) => {
          if (!csvString) return;
          const blob = new Blob([csvString], { type: "text/csv;charset=utf-8" });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
        };

        const timestamp = Date.now();
        const randomNum = Math.floor(Math.random() * 10000);

        if (res.data.depositCSV) downloadCSV(res.data.depositCSV, `Deposit_Summary_${timestamp}_${randomNum}.csv`);
      } else {
        let csvData;
        if (typeof res.data === "string") {
          csvData = res.data;
        } else if (res.data instanceof Blob) {
          csvData = res.data;
        } else {
          // Can't handle unknown format, show error
          throw new Error("Unexpected response format for CSV");
        }

        const blob =
          csvData instanceof Blob
            ? csvData
            : new Blob([csvData], { type: "text/csv;charset=utf-8" });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        const timestamp = Date.now();
        const randomNum = Math.floor(Math.random() * 10000);
        const fileName = `Report_${timestamp}_${randomNum}.csv`;
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    })
    .catch((err) => {
      console.log(err);
      alert(err?.response?.data?.message || "Download failed");
    })
    .finally(() => {
      setDownloadLoading(false);
    });
  };

  return (

    <>
      {downloadLoading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <CircularProgress size={60} thickness={5} style={{ color: "white" }} />
          <Typography mt={2} variant="h6" color="white">
            Downloading report...
          </Typography>
        </Box>
      )}
      <Box>
        <Card variant="outlined">
          <CardContent>
            <Grid 
              container
              spacing={2}
              alignItems="center"  // Align items vertically in the center
              sx={{ marginTop: "10px" }}
            >
              <Typography 
                variant="h6"
                gutterBottom
                sx={{
                  fontWeight: 'bold',
                  color: '#1976d2',
                  fontSize: '1.5rem',
                  textTransform: 'uppercase',
                  letterSpacing: 1,
                }}
              >MERCHANT TRANSACTIONS</Typography>
              <Grid 
                container
                spacing={2}
                alignItems="flex-start" 
                sx={{ marginTop: "10px" }}
              >
                {/* 1st Row */}
                <Grid item xs={12} sm={6}>
                  <TextField 
                    id="outlined-basic" 
                    label="Order ID" 
                    variant="outlined" 
                    fullWidth 
                    name="text"
                    value={searchItem}
                    onChange={(e) => setSearchItem(e.target.value)} 
                    InputProps={{
                      endAdornment: searchItem && (
                        <InputAdornment position="end">
                          <IconButton onClick={handleClear} edge="end">
                            <ClearIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={6} sm={2}>
                  <FilterCreatedOn setCreatedTo={setCreatedTo} setCreatedFrom={setCreatedFrom} />
                </Grid>
                <Grid item xs={6} sm={2}>
                  <FilterUpdatedOn setUpdatedTo={setUpdatedTo} setUpdatedFrom={setUpdatedFrom} />
                </Grid>
                <Grid item xs={12} sm={2}>
                  {/* <Button variant="contained" color="primary" sx={{ mr: 1, mb: 1, }} size="large" onClick={downloadExl}> Download </Button> */}
                </Grid>

                {/* 2nd Row */}
                <Grid item xs={12} sm={4}>
                  <Autocomplete
                    multiple
                    id="checkboxes-tags-demo"
                    options={methods}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.label || ""}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.label}
                      </li>
                    )}
                    fullWidth
                    renderTags={(value) =>
                      value.length > 0 ? `${value.length} value(s) selected` : ""
                    }
                    value={methods.filter((item) => selectedMethods.includes(item.value))} // Convert stored values back to objects
                    onChange={handleChange1}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Method" />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Autocomplete
                    multiple
                    id="checkboxes-tags-demo"
                    options={types}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.label || ""}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.label}
                      </li>
                    )}
                    fullWidth
                    renderTags={(value) =>
                      value.length > 0 ? `${value.length} value(s) selected` : ""
                    }
                    value={types.filter((item) => selectedTypes.includes(item.value))} // Convert stored values back to objects
                    onChange={handleChange}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Status" />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Autocomplete
                    multiple
                    id="checkboxes-tags-demo"
                    options={currencyName}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.label || ""}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.label}
                      </li>
                    )}
                    fullWidth
                    renderTags={(value) =>
                      value.length > 0 ? `${value.length} value(s) selected` : ""
                    }
                    value={selectedCurrencies}
                    onChange={(event, newValue) => setSelectedCurrencies(newValue)}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Currencies" />
                    )}
                  />
                </Grid>
              </Grid>

            </Grid>
            <Box
              sx={{
                overflow: {
                  xs: "auto",
                  sm: "unset",
                },
              }}
            >
              <SandboxDepositsTable merchant={merchant} message={message} page={page} totalPage={totalPage} setPage={setPage} auth={auth} ReadData={ReadData} authRead={authRead} authUpdate={authUpdate} authDelete={authDelete} refundCharges={refundCharges} loading={loading} />
            </Box>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default SandboxDeposits;